module.exports = __webpack_public_path__ + "static/media/96.6ccb34d7.webp";